// Mock data for Shailey Singh Portfolio - Adobe Enterprise Aesthetic

export const heroData = {
  headline: "Shailey Singh",
  subheadline: "Building brands at the frontier of AI, Web3, Fintech and Robotics.",
  description: "Marketing & Growth Professional specializing in Blockchain, AI, Robotics, DeFi, and Institutional Finance. I bridge complex infrastructure with human adoption through strategic positioning and market growth."
};

export const aboutData = {
  credentials: [
    { name: "IIT Bombay", type: "Education" },
    { name: "IIM-Adjacent", type: "Management" },
    { name: "PhD - Management", type: "Research" }
  ],
  bio: "With over a decade of experience in Fintech, Healthcare, AI, and Web3, combined with a PhD focused on Gen Z consumer behavior, I bridge the gap between complex challenges, flagship solutions, and human adoption. My approach is grounded in high-stakes storytelling and sustainable growth strategies."
};

export const caseStudies = [
  {
    id: 1,
    title: "Mudrex",
    subtitle: "Tokenization and Digital Assets",
    category: "MARKETING, CONTENT & COMMS",
    description: "Leading marketing, content, brand, and communications initiatives for a modern fintech platform, with products spanning US stocks, tokenization and digital assets. Driving narrative development, thought leadership, PR, research-led content and integrated marketing initiatives, including the launch of the flagship Bond Tokenization Report at Global Fintech Festival 2026.",
    metrics: [
      { label: "Ranking in", value: "AI Overviews, AEO, GEO" },
      { label: "Focus", value: "Y Combinator-backed" },
      { label: "Highest SOV", value: "US Stocks (META, NVDA, SPCX)" }
    ],
    websiteEmbed: "https://drive.google.com/file/d/1JXYMHPe944pFNCGkF3ts5QxWvXJFLHsC/preview",
    websiteUrl: "https://drive.google.com/file/d/1JXYMHPe944pFNCGkF3ts5QxWvXJFLHsC/view?pli=1",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/oo3vj68g_1789476814117.jpg",
    alignment: "left"
  },
  {
    id: 2,
    title: "Santage AI",
    subtitle: "The Future of Intelligence",
    category: "AI PRODUCT",
    description: "Built Santage AI from the ground up as an AI-native news and knowledge platform, combining editorial intelligence, AI-assisted workflows, SEO/AEO/GEO, structured knowledge and LLM-ready content architecture. Developed the platform, content systems and AI workflows to turn emerging AI developments into searchable, structured and citation-ready intelligence.",
    metrics: [
      { label: "Role", value: "Founder" },
      { label: "Built", value: "AI agents, models" },
      { label: "Stack", value: "AI Workflows · LLMs" }
    ],
    websiteEmbed: "https://santageai.com/",
    websiteUrl: "https://santageai.com/",
    image: "https://santageai.com/",
    alignment: "right"
  },
  {
    id: 3,
    title: "Avail",
    subtitle: "The Nexus Effect",
    category: "Product Marketing",
    description: "Led Avail's global repositioning from a single Data Availability layer to a full modular crosschain infrastructure stack (TurboDA, EnigmaDA, Light Clients, Nexus interop, Fusion restaking), reshaping the category narrative and value propositions for developers, protocols, and institutions.",
    metrics: [
      { label: "Mainnet Launch", value: "50+ apps and chain partners" },
      { label: "Upcoming", value: "x402, Agentic systems" },
      { label: "Category", value: "Cross-chain Infra" }
    ],
    twitterVideoUrl: "https://x.com/AvailProject/status/1993653720899620869",
    blogUrl: "https://blog.availproject.org/author/shailey/",
    image: "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e",
    citiReport: true,
    alignment: "left"
  },
  {
    id: 4,
    title: "Neon EVM",
    subtitle: "Solana Network Extension",
    category: "GTM & ECOSYSTEM",
    description: "Orchestrated the Points Program and market category creations: 'Parallel EVM'. 8,200%+ onchain growth with 73% increase in tier-1 industry mentions. Built strategic partnerships across 25+ applications and positioned Neon EVM as the Pioneer Solana Network Extension.",
    metrics: [
      { label: "Growth", value: "8,200%+ onchain user growth" },
      { label: "Partnerships", value: "25+ tier-1 partners" },
      { label: "Category", value: "EVM-SVM Compatibility" }
    ],
    websiteUrl: "https://cryptoslate.com/press-releases/neon-evm-adopts-network-extensions-to-redefine-solanas-product-categories/",
    coindeskVideo: "https://www.coindesk.com/video/neon-evm-partners-with-debridge-protocol",
    image: "https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg",
    dashboardMockup: true,
    alignment: "right"
  },
  {
    id: 5,
    title: "Fancy Studios",
    subtitle: "Gaming GTM",
    category: "CONTENT & COMMUNITY",
    description: "Led Fancy Birds to the #4 Blockchain Game (Cointelegraph Ranking 2022) through strategic partnerships and community-first marketing. Executed high-energy campaigns that resonated with both Web3 natives and traditional gamers.",
    metrics: [
      { label: "Ranking", value: "#4 Blockchain Game" },
      { label: "Community", value: "60K+ community" },
      { label: "Partnerships", value: "Illuvium x DeQuest" }
    ],
    twitterVideoUrl: "https://x.com/Fancybirdsio/status/1666821897567469576",
    websiteUrl: "https://fancy-studios.gitbook.io/whitepaper",
    image: "https://images.unsplash.com/photo-1762279389042-9439bfb6c155",
    alignment: "left"
  },
  {
    id: 6,
    title: "Emerging Tech",
    subtitle: "AI, Robotics & Fintech",
    category: "Strategic Partnerships",
    description: "Led emerging technology initiatives across AI, robotics and fintech, developing strategic positioning and go-to-market narratives for enterprise adoption (AWS Bedrock). Worked across initiatives with Epic Games, Abbott and others.",
    metrics: [
      { label: "Technology", value: "AWS Bedrock" },
      { label: "Focus", value: "AI · Robotics · Fintech" },
      { label: "Market", value: "Enterprise AI" }
    ],
    videoUrl: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/awer6qfb_Create_Looping_Video_With_Text.mp4",
    websiteUrl: "https://economictimes.indiatimes.com/tech/technology/transforming-businesses-with-ai-applied-cloud-computings-vision-and-strategy/articleshow/105419837.cms?from=mdr",
    image: "https://images.unsplash.com/photo-1579548122080-c35fd6820ecb",
    alignment: "right"
  },
  {
    id: 7,
    title: "Avail x Arcana",
    subtitle: "Infrastructure",
    category: "MERGERS & ACQUISITIONS",
    description: "Architected a multi-channel communication strategy to provide the market transparency needed for technology and talent acquisitions. Aligned investor relations, community, and partner interests to build the strategic consensus.",
    metrics: [
      { label: "Type", value: "Technology and acqui-hire" },
      { label: "Focus", value: "Cross-chain infra" },
      { label: "Market", value: "Blockchain" }
    ],
    placardImage: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/2ebu7sjz_Arcana.png",
    websiteUrl: "https://www.theblock.co/post/368483/founders-fund-backed-avail-acquires-arcana-offering-xar-token-holders-41-swap-into-avail",
    image: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/2ebu7sjz_Arcana.png",
    alignment: "left"
  }
];

export const ecosystemPartners = [
  { 
    name: "Solana", 
    color: "#14F195",
    logo: "https://cryptologos.cc/logos/solana-sol-logo.svg"
  },
  { 
    name: "Ethereum", 
    color: "#627EEA",
    logo: "https://cryptologos.cc/logos/ethereum-eth-logo.svg"
  },
  { 
    name: "TRON", 
    color: "#EB0029",
    logo: "https://cryptologos.cc/logos/tron-trx-logo.svg"
  },
  { 
    name: "BNB Chain", 
    color: "#F3BA2F",
    logo: "https://cryptologos.cc/logos/bnb-bnb-logo.svg"
  },
  { 
    name: "Lens", 
    color: "#00501E",
    logo: "https://customer-assets.emergentagent.com/job_maximalist-marketing/artifacts/h1g9oa7t_Lens%20logo.jpg"
  },
  { 
    name: "Arbitrum", 
    color: "#28A0F0",
    logo: "https://cryptologos.cc/logos/arbitrum-arb-logo.svg"
  },
  { 
    name: "Monad", 
    color: "#6366F1",
    logo: "https://customer-assets.emergentagent.com/job_maximalist-marketing/artifacts/k4tg4i3x_Monad%20logo.png"
  },
  { 
    name: "MegaETH", 
    color: "#FF6B6B",
    logo: "https://customer-assets.emergentagent.com/job_maximalist-marketing/artifacts/zk1e54ny_MegaETH%20logo.jpg"
  },
  { 
    name: "Eclipse", 
    color: "#8B5CF6",
    logo: "https://customer-assets.emergentagent.com/job_maximalist-marketing/artifacts/laenwgy3_Eclispe%20logo.jpg"
  },
  { 
    name: "Polygon", 
    color: "#8247E5",
    logo: "https://cryptologos.cc/logos/polygon-matic-logo.svg"
  },
  { 
    name: "Epic Games", 
    color: "#000000",
    logo: "https://upload.wikimedia.org/wikipedia/commons/3/31/Epic_Games_logo.svg"
  },
  { 
    name: "AWS", 
    color: "#FF9900",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
  }
];

export const thoughtLeadership = {
  sentiment: "96%",
  growth: "175%",
  platform: "Featured Across Industry",
  articles: [
    {
      id: 1,
      title: "Shaping the discourse on AI, Web3, Stablecoins and Fintech",
      excerpt: "How technology and human intersection are reshaping the Web architecture and enabling new paradigms.",
      date: "2024",
      category: "EXPERTISE",
      mediaType: "image",
      mediaUrl: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/pnojt11c_1.png"
    },
    {
      id: 2,
      title: "Gen Z Marketing: Purchase and Adoption Behavior",
      excerpt: "Understanding the behavioral patterns driving next-generation users and their impact on product design.",
      date: "2025",
      category: "Research",
      mediaType: "image",
      mediaUrl: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/ih3yk7jx_2.png"
    },
    {
      id: 3,
      title: "Marketing in the Age of AI & Robotics",
      excerpt: "Strategic positioning for emerging tech products in a rapidly evolving landscape.",
      date: "2025",
      category: "Book Published",
      mediaType: "image",
      mediaUrl: "https://customer-assets.emergentagent.com/job_58319eb3-9b5f-4bbb-8108-c6d0d0efcbbe/artifacts/8ugxhlmd_3.png"
    }
  ]
};

export const contactData = {
  telegram: "@Sentinelmax",
  email: "shaileysingh56@gmail.com",
  linkedin: "https://in.linkedin.com/in/dr-shailey-singh"
};